/*
 * 接口统一集成模块
 */

//admin
import * as login from './modules/admin/login'
import * as user from './modules/admin/user'
import * as dept from './modules/admin/dept'
import * as role from './modules/admin/role'
import * as menu from './modules/admin/menu'
import * as dict from './modules/admin/dict'
import * as config from './modules/admin/config'
import * as log from './modules/admin/log'
import * as loginlog from './modules/admin/loginlog'

//regplan
import * as appointment from './modules/regplan/appointment'
import * as scheduling from './modules/regplan/scheduling'
import * as schedulingCancel from './modules/regplan/schedulingCancel'
import * as schedulingHistory from './modules/regplan/schedulingHistory'
import * as schedulingTemplate from './modules/regplan/schedulingTemplate'
import * as schedulingTemplateFather from './modules/regplan/schedulingTemplateFather'
import * as sourceDetail from './modules/regplan/sourceDetail'
import * as sourceDetailHistory from './modules/regplan/sourceDetailHistory'

//pub
import * as departments from './modules/pub/departments'
import * as hospital from './modules/pub/hospital'
import * as doctor from './modules/pub/doctor'
import * as commodity from './modules/pub/commodity'
import * as information from './modules/pub/Information'
import * as bindInfo from './modules/pub/billInfo'
import * as billClassify from './modules/pub/billClassify'
//user
import * as patients from './modules/user/patients'
import * as userInfo from './modules/user/userInfo'
import * as patientHospital from './modules/user/patientHospital'
import * as userAuthorization from './modules/user/userAuthorization'
import * as userLoginHistory from './modules/user/userLoginHistory'
import * as userPatientRelation from './modules/user/userPatientRelation'

//quartz
import * as quartzInfo from './modules/quartz/quartzInfo'

// 默认全部导出
export default {
  login,
  user,
  dept,
  role,
  menu,
  dict,
  config,
  log,
  loginlog,
  appointment,
  scheduling,
  schedulingCancel,
  schedulingHistory,
  schedulingTemplate,
  schedulingTemplateFather,
  sourceDetail,
  sourceDetailHistory,
  departments,
  hospital,
  doctor,
  quartzInfo,
  bindInfo,
  billClassify,
  patients,
  userInfo,
  patientHospital,
  userAuthorization,
  userLoginHistory,
  commodity,
  userPatientRelation,
  information
}



// WEBPACK FOOTER //
// ./src/http/api.js